import React from 'react';
import './Bpo.css';
import { useState } from 'react';

const ContactCenterSection = () => {

const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How does the AI-powered routing work?",
      answer: "Our AI analyzes customer intent, historical behavior, and agent skills in real-time to route calls to the most qualified agent—reducing wait times by up to 40% and improving first-contact resolution."
    },
    {
      question: "Can I integrate Toxbox with my existing CRM?",
      answer: "Yes! Toxbox offers native integrations with major CRM platforms like Salesforce, HubSpot, and Zendesk. We also provide a robust API and webhook system for custom integrations with any platform."
    },
    {
      question: "What kind of support do you offer?",
      answer: "We provide 24/7 live chat support, dedicated account managers for enterprise clients, and an AI-powered knowledge base with step-by-step guides and video tutorials."
    },
    {
      question: "How secure is my data on Toxbox?",
      answer: "Bank-level security: 256-bit AES encryption at rest, TLS 1.3 in transit, SOC 2 Type II, GDPR, HIPAA, and PCI DSS compliant. All data is isolated per tenant with role-based access control."
    },
    {
      question: "Is there a free trial available?",
      answer: "Yes — start with a 14-day free trial. No credit card required. You’ll get full access to Starter plan features, including up to 10 agents and basic AI routing."
    },
    {
      question: "Can I customize the AI models for my specific use case?",
      answer: "Absolutely. Our Professional and Enterprise plans include custom AI training — you can fine-tune models on your historical data, industry-specific terminology, and unique workflows."
    }
  ];

  return (
    <div>
    <section className="contact-center-section">
      <div className="contact-center-container">
        {/* Top Banner */}
        <div className="tech-badge">
          Powered by Advanced AI/ML Technology
        </div>

        {/* Main Heading */}
        <h1 className="contact-center-title">
          Your Contact Center
          <br />
          <span className="ai-highlight">Powered by AI/ML</span>
        </h1>

        {/* Subtitle */}
        <p className="contact-center-subtitle">
          Transform customer interactions with intelligent automation.
          Reduce costs, boost satisfaction, and scale effortlessly with
          enterprise-grade AI.
        </p>

        {/* CTA Buttons */}
        <div className="contact-cta-wrapper">
          <button className="btn-primary1">Start Free Trial</button>
          <button className="btn-outline1">View Demo</button>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-value">94%</div>
            <div className="stat-label">Customer Satisfaction</div>
            <div className="stat-desc">Industry leading CSAT scores</div>
          </div>

          <div className="stat-item">
            <div className="stat-value">92%</div>
            <div className="stat-label">Resolution Rate</div>
            <div className="stat-desc">First contact resolution</div>
          </div>

          <div className="stat-item">
            <div className="stat-value">-73%</div>
            <div className="stat-label">Operating Costs</div>
            <div className="stat-desc">Average cost reduction</div>
          </div>

          <div className="stat-item">
            <div className="stat-value">99%</div>
            <div className="stat-label">Uptime SLA</div>
            <div className="stat-desc">Enterprise reliability</div>
          </div>
        </div>
      </div>
    </section>

<section className="ai-industry-section">
  <div className="ai-industry-container">
    {/* Left Side */}
    <div className="ai-content-left">
      <div className="badge">Industry Leading</div>

      <h2 className="industry-title">
        The AI/ML Industry is
        <span className="boom-highlight"> Booming</span>
      </h2>

      <p className="industry-desc">
        Join thousands of forward-thinking companies leveraging AI to
        revolutionize customer service. Our platform combines cutting-edge
        machine learning with intuitive design to deliver unprecedented results.
      </p>

      <div className="features-list">
        <div className="feature-item">
          <span className="checkmark">✓</span>
          <div>
            <h3 className="feature-title">Real-time AI Processing</h3>
            <p className="feature-text">
              Instant customer intent recognition and smart routing
            </p>
          </div>
        </div>

        <div className="feature-item">
          <span className="checkmark">✓</span>
          <div>
            <h3 className="feature-title">Continuous Learning</h3>
            <p className="feature-text">
              AI models that improve with every interaction
            </p>
          </div>
        </div>

        <div className="feature-item">
          <span className="checkmark">✓</span>
          <div>
            <h3 className="feature-title">Predictive Analytics</h3>
            <p className="feature-text">
              Anticipate customer needs and optimize support workflows
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* Right Side - Stats Card */}
    <div className="stats-card">
      <div className="stat-row">
        <span className="stat-label">Market Growth</span>
        <span className="stat-value">+156%</span>
      </div>

      <div className="progress-bar">
        <div className="progress-fill" style={{ width: '85%' }}></div>
      </div>

      <div className="stat-values">
        <div className="stat-box">
          <div className="stat-number">$2.4B</div>
          <div className="stat-caption">Market Size 2026</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">89%</div>
          <div className="stat-caption">Adoption Rate</div>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="hyperscale-section">
  <div className="hyperscale-container">
    {/* Top Badge */}
    <div className="core-features-badge">Core Features</div>

    {/* Main Title */}
    <h1 className="hyperscale-title">
      Hyperscale Your <span className="ops-highlight">Operations</span>
    </h1>

    {/* Subtitle */}
    <p className="hyperscale-subtitle">
      Built for enterprise scale with features that adapt to your growing needs
    </p>

    {/* 6 Cards Grid */}
    <div className="features-grid">
      <div className="feature-card1">
        <div className="feature-icon"><span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-icon lucide-message-square"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/></svg></span></div>
        <h3 className="feature-title">Intelligent Routing</h3>
        <p className="feature-desc">
          AI-powered smart routing ensures every customer reaches the right agent at the right time, maximizing efficiency.
        </p>
        <ul className="feature-points">
          <li>Skill-based distribution</li>
          <li>Priority queue management</li>
        </ul>
      </div>

      <div className="feature-card1">
        <div className="feature-icon"><span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column-icon lucide-chart-column"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg></span></div>
        <h3 className="feature-title">Real-time Analytics</h3>
        <p className="feature-desc">
          Comprehensive dashboards provide actionable insights into every aspect of your contact center performance.
        </p>
        <ul className="feature-points">
          <li>Live performance metrics</li>
          <li>Custom reporting tools</li>
        </ul>
      </div>

      <div className="feature-card1">
        <div className="feature-icon"><span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M16 3.128a4 4 0 0 1 0 7.744"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/></svg></span></div>
        <h3 className="feature-title">Agent Empowerment</h3>
        <p className="feature-desc">
          Equip your team with AI-assisted tools that provide instant customer context and suggested responses.
        </p>
        <ul className="feature-points">
          <li>AI response suggestions</li>
          <li>Unified customer view</li>
        </ul>
      </div>

      <div className="feature-card1">
        <div className="feature-icon"><span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone-icon lucide-phone"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/></svg></span></div>
        <h3 className="feature-title">Omnichannel Support</h3>
        <p className="feature-desc">
          Seamlessly manage voice, chat, email, and social media from a single unified platform.
        </p>
        <ul className="feature-points">
          <li>Cross-channel continuity</li>
          <li>Channel-agnostic workflows</li>
        </ul>
      </div>

      <div className="feature-card1">
        <div className="feature-icon"><span>⚡</span></div>
        <h3 className="feature-title">Automation Engine</h3>
        <p className="feature-desc">
          Automate repetitive tasks and let AI handle routine inquiries, freeing agents for complex issues.
        </p>
        <ul className="feature-points">
          <li>Workflow automation</li>
          <li>Chatbot integration</li>
        </ul>
      </div>

      <div className="feature-card1">
        <div className="feature-icon"><span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe-icon lucide-globe"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg></span></div>
        <h3 className="feature-title">Global Scalability</h3>
        <p className="feature-desc">
          Deploy across regions with multi-language support and compliance with local regulations.
        </p>
        <ul className="feature-points">
          <li>50+ languages supported</li>
          <li>Regional data centers</li>
        </ul>
      </div>
    </div>
  </div>
</section>

    <section className="technical-excellence-section">
      <div className="technical-excellence-container">
        {/* Main Title */}
        <h1 className="tech-title">
          Technical <span className="excellence-highlight">Excellence</span>
        </h1>

        {/* 3 Cards Grid */}
        <div className="tech-cards-grid">
          {/* Card 1: REST & GraphQL APIs */}
          <div className="tech-card">
            <div className="tech-icon">
              <span>⟨⟩</span>
            </div>
            <h3 className="tech-title-card">REST & GraphQL APIs</h3>
            <p className="tech-desc">
              Flexible APIs with comprehensive documentation and SDKs for all major languages.
            </p>
            <div className="tech-code-block">
              <pre className="code-snippet">
                curl -X POST \<br />
                <span className="code-url">api.toxbox.ai/v1/calls</span>
              </pre>
            </div>
          </div>

          {/* Card 2: Webhook Integration */}
          <div className="tech-card">
            <div className="tech-icon">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-database-icon lucide-database"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5V19A9 3 0 0 0 21 19V5"/><path d="M3 12A9 3 0 0 0 21 12"/></svg></span>
            </div>
            <h3 className="tech-title-card">Webhook Integration</h3>
            <p className="tech-desc">
              Real-time event streaming to your systems for seamless workflow automation.
            </p>
            <ul className="tech-features">
              <li>✓ call.initiated</li>
              <li>✓ agent.assigned</li>
              <li>✓ call.completed</li>
            </ul>
          </div>

          {/* Card 3: Cloud Native */}
          <div className="tech-card">
            <div className="tech-icon">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-cloud-icon lucide-cloud"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/></svg></span>
            </div>
            <h3 className="tech-title-card">Cloud Native</h3>
            <p className="tech-desc">
              Built on modern cloud infrastructure for reliability, scalability, and performance.
            </p>
            <div className="tech-tags">
              <span className="tag">AWS</span>
              <span className="tag">Azure</span>
              <span className="tag">GCP</span>
              <span className="tag">Kubernetes</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="pricing-section1">
      <div className="pricing-container1">
        {/* Top Badge */}
        <div className="flexible-pricing-badge1">Flexible Pricing</div>

        {/* Main Title */}
        <h1 className="pricing-title1">
          Plans for Every <span className="scale-highlight">Scale</span>
        </h1>

        {/* Subtitle */}
        <p className="pricing-subtitle1">
          Start free, scale as you grow. No hidden fees.
        </p>

        {/* 3 Plans Grid */}
        <div className="plans-grid">
          {/* Starter Plan */}
          <div className="plan-card">
            <div className="plan-header">
              <h3 className="plan-name">Starter</h3>
            </div>
            <div className="plan-price">$29</div>
            <div className="plan-billing">per agent/month</div>
            <button className="btn-outline">Start Free Trial</button>
            <ul className="plan-features">
              <li>✓ Up to 10 agents</li>
              <li>✓ Basic AI features</li>
              <li>✓ Email & chat support</li>
              <li>✓ Standard analytics</li>
              <li>✓ 99% uptime SLA</li>
            </ul>
          </div>

          {/* Professional Plan (Most Popular) */}
          <div className="plan-card popular">
            <div className="plan-header">
              <span className="popular-badge">Most Popular</span>
              <h3 className="plan-name">Professional</h3>
            </div>
            <div className="plan-price">$79</div>
            <div className="plan-billing">per agent/month</div>
            <button className="btn-primary">Start Free Trial</button>
            <ul className="plan-features">
              <li>✓ Up to 100 agents</li>
              <li>✓ Advanced AI & ML</li>
              <li>✓ Priority support</li>
              <li>✓ Custom analytics</li>
              <li>✓ 99.9% uptime SLA</li>
              <li>✓ API access</li>
            </ul>
          </div>

          {/* Enterprise Plan */}
          <div className="plan-card">
            <div className="plan-header">
              <h3 className="plan-name">Enterprise</h3>
            </div>
            <div className="plan-price">Custom</div>
            <div className="plan-billing">tailored pricing</div>
            <button className="btn-outline">Contact Sales</button>
            <ul className="plan-features">
              <li>✓ Unlimited agents</li>
              <li>✓ Custom AI training</li>
              <li>✓ 24/7 dedicated support</li>
              <li>✓ White-label options</li>
              <li>✓ 99.99% uptime SLA</li>
              <li>✓ On-premise deployment</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section className="enterprise-platform-section">
      <div className="enterprise-platform-container">
        {/* Top Badge */}
        <div className="enterprise-ready-badge">Enterprise Ready</div>

        {/* Main Title */}
        <h1 className="platform-title">
          Enterprise-Grade <span className="platform-highlight">Platform</span>
        </h1>

        {/* 2 Cards Grid */}
        <div className="platform-cards-grid">
          {/* Card 1: Security & Compliance */}
          <div className="platform-card">
            <div className="platform-icon">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg></span>
            </div>
            <h3 className="platform-title-card">Security & Compliance</h3>
            <p className="platform-desc">
              Bank-level security with comprehensive compliance certifications to protect your data.
            </p>
            <div className="certifications">
              <span className="cert-badge">SOC 2 Type II</span>
              <span className="cert-badge">GDPR</span>
              <span className="cert-badge">HIPAA</span>
              <span className="cert-badge">PCI DSS</span>
            </div>
          </div>

          {/* Card 2: Data Protection */}
          <div className="platform-card">
            <div className="platform-icon">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock-keyhole-icon lucide-lock-keyhole"><circle cx="12" cy="16" r="1"/><rect x="3" y="10" width="18" height="12" rx="2"/><path d="M7 10V7a5 5 0 0 1 10 0v3"/></svg></span>
            </div>
            <h3 className="platform-title-card">Data Protection</h3>
            <p className="platform-desc">
              End-to-end encryption, role-based access control, and comprehensive audit logs.
            </p>
            <ul className="protection-features">
              <li>✓ 256-bit AES encryption at rest</li>
              <li>✓ TLS 1.3 in transit</li>
              <li>✓ SSO/SAML integration</li>
              <li>✓ Complete audit trails</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section className="integration-section">
      <div className="integration-container">
        {/* Top Badge */}
        <div className="seamless-integration-badge">Seamless Integration</div>

        {/* Main Title */}
        <h1 className="integration-title">
          Works With Your <span className="stack-highlight">Stack</span>
        </h1>

        {/* Subtitle */}
        <p className="integration-subtitle">
          Connect with your existing tools and workflows in minutes
        </p>

        {/* 10 Integration Badges Grid */}
        <div className="integrations-grid">
          <div className="integration-badge">Salesforce</div>
          <div className="integration-badge">Zendesk</div>
          <div className="integration-badge">HubSpot</div>
          <div className="integration-badge">Slack</div>
          <div className="integration-badge">Microsoft Teams</div>
          <div className="integration-badge">Shopify</div>
          <div className="integration-badge">Twilio</div>
          <div className="integration-badge">ServiceNow</div>
          <div className="integration-badge">Intercom</div>
          <div className="integration-badge">Zoom</div>
          <div className="integration-badge">AWS</div>
          <div className="integration-badge">Google Cloud</div>
        </div>
      </div>
    </section>

    <section className="final-faq-section">
  <div className="final-faq-container">
    {/* Header */}
    <h2 className="faq-title">
      Still Have <span className="faq-highlight">Questions?</span>
    </h2>
    <p className="faq-subtitle">
      Find answers to common questions about our platform
    </p>

    {/* Accordion List */}
    <div className="faq-list">
      {faqs.map((faq, index) => (
        <div key={index} className="faq-item">
          <button
            className={`faq-question ${openIndex === index ? 'active' : ''}`}
            onClick={() => toggleAccordion(index)}
            aria-expanded={openIndex === index}
            aria-controls={`answer-${index}`}
          >
            <span className="faq-question-text">{faq.question}</span>
            <span className="faq-arrow">
              {openIndex === index ? '▲' : '▼'}
            </span>
          </button>

          <div
            id={`answer-${index}`}
            className={`faq-answer ${openIndex === index ? 'open' : ''}`}
            role="region"
            aria-hidden={openIndex !== index}
          >
            <p className="faq-answer-text">{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>

    {/* CTA */}
    <div className="faq-cta">
      <p className="faq-cta-text">Can't find what you're looking for?</p>
      <button className="btn-primary">Contact Support</button>
    </div>
  </div>
</section>

    <section className="final-cta-section">
      <div className="final-cta-container">
        {/* Main Title */}
        <h2 className="cta-title">
          Ready to Transform Your
          <br />
          <span className="center-highlight">Contact Center?</span>
        </h2>

        {/* Subtitle */}
        <p className="cta-subtitle">
          Join thousands of companies already using Toxbox to deliver exceptional customer experiences
        </p>

        {/* CTA Buttons */}
        <div className="cta-buttons">
          <button className="btn-primary1">Start Free Trial</button>
          <button className="btn-outline1">Schedule Demo</button>
        </div>
      </div>
    </section>

</div>
    
  );
};

export default ContactCenterSection;
